import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "app/auth/base";
import { closeLoading, openLoading } from "app/store/trackingApp/loadingSlice";
import { openToast } from "app/store/trackingApp/toastSlice";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";
import TrackingUtils from "@tracking/utils/TrackingUtils";

export const getTabelaVariaveis = createAsyncThunk(
  "variaveisApp/tabelas/getTabelaVariaveis",
  async (data: any, { dispatch }) => {
    let response;
    dispatch(openLoading());
    try {
      response = await API.get("/variavel-tabelas", { params: data });
    } catch (err) {
      dispatch(
        openModalError({
          title: "Não foi possível buscar as tabelas!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err);
    }
    dispatch(closeLoading());
    return response.data;
  }
);

export const saveTabelaVariavel = createAsyncThunk(
  "variaveisApp/tabelas/saveTabelaVariavel",
  async (data: any, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    try {
      await API.post("/variavel-tabelas", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Tabela cadastrada",
        })
      );
      dispatch(
        getTabelaVariaveis(
          Object.keys(requestGetParams.variaveisApp.tabelas.requestGetParams)
            .length > 0
            ? requestGetParams.variaveisApp.tabelas.requestGetParams
            : { pagina: 1, itensPorPagina: 15 }
        )
      );
    } catch (err) {
      dispatch(
        openModalError({
          title: "Não foi possível cadastrar a tabela!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err);
    }
    return {};
  }
);

export const editTabelaVariavel = createAsyncThunk(
  "variaveisApp/tabelas/editTabelaVariavel",
  async (data: any, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    try {
      await API.put("/variavel-tabelas", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Tabela editada",
        })
      );
      dispatch(
        getTabelaVariaveis(
          requestGetParams.variaveisApp.tabelas.requestGetParams
        )
      );
    } catch (err) {
      dispatch(
        openModalError({
          title: "Não foi possível editar a tabela!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err);
    }
    return {};
  }
);

export const deleteTabelaVariavel = createAsyncThunk(
  "variaveisApp/tabelas/deleteTabelaVariavel",
  async (data: any, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    try {
      await API.delete(
        TrackingUtils.buildQueryString("/variavel-tabelas", data)
      );
      dispatch(
        openToast({
          severity: "success",
          title: "Tabela removida",
        })
      );
      dispatch(
        getTabelaVariaveis(
          requestGetParams.variaveisApp.tabelas.requestGetParams
        )
      );
    } catch (err) {
      dispatch(
        openModalError({
          title: "Não foi possível remover a tabela!",
          text: "Se certifique que a solicitação está correta",
          btnLabel: "Voltar",
        })
      );
      console.error(err);
    }
    return {};
  }
);
